import React, { useCallback } from 'react'
import { FormRow } from '@/components/changeRequests/formRow'
import { usePropertyReader } from '@/hooks/usePropertyReader'

function ValidDates (props) {
  const since = props.fromName || 'validFrom'
  const until = props.toName || 'validTo'
  const [validTo, validFrom] = usePropertyReader([until, since])
  const validFromValidate = useCallback(x => x.value && validTo && x.value > validTo && 'Validations.InvalidFrom', [validTo])
  const validToValidate = useCallback(x => x.value && validFrom && x.value < validFrom && 'Validations.InvalidTo', [validFrom])
  return (
    <React.Fragment>
      <FormRow
        label={props.fromKey || 'Common.ValidFrom'} name={since} inputType='date'
        required={props.validFromRequired}
        onValidate={validFromValidate}
        readonly={props.readonly}
        target={props.target} />
      <FormRow
        label={props.toKey || 'Common.ValidTo'} name={until} inputType='date'
        required={props.validToRequired}
        onValidate={validToValidate}
        disabled={props.validToDisabled}
        readonly={props.readonly}
        target={props.target} />
    </React.Fragment>
  )
}

export {
  ValidDates
}



// WEBPACK FOOTER //
// ./src/components/changeRequests/common/validDates.js